module.exports = __webpack_public_path__ + "img/PPMP22.29ad636d.png";